module.exports = function CodesReducer(state = {}, action = {}) {
  switch (action.type) {
    case 'UNKNOWN_CODE_TYPE':
    default:
      return state;
  }
};
